/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export type API49813Item = {};
    
  



  export type API49813Req = {};



export interface API49813Res {
  /** 是否有权限,false:没有权限,true:有权限  */
  havePermission?: boolean;
  /** 平均项目健康指数  */
  avgProjectHealthFlag?: number;
  /** 项目状态（1：正常；2：风险；3：失控4：预警）  */
  projectStatus?: number;
  /** 增长率，比上周  */
  increaseRateDou?: number;
  /**   */
  increaseRateStr?: string;
  /** 广播信息 ,String  */
  broadcastMsgList?: string[];
  
};


// 49813 项目大盘 - 视图

export interface IUseGetAPI49813Return {
  /** 项目大盘 - 视图: 接口请求状态 */
  isAPI49813Loading: boolean;
  /** 项目大盘 - 视图: 接口请求返回数据 */
  dataAPI49813: API49813Res;
  /**  项目大盘 - 视图: 接口数据请求方法 */
  fetchAPI49813Data:  ( config?: YWRequestConfig) => Promise<API49813Res>;
  /** 项目大盘 - 视图: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI49813 = ():IUseGetAPI49813Return => {
  let isMount = true;
  const [isAPI49813Loading, setIsAPI49813Loading] = useState(false);
  const [dataAPI49813, setDataAPI49813] = useState<API49813Res>({} as API49813Res);
  const requestUrl = `${basePath}/corp-admin/project/bi/view/v2`;

  const fetchAPI49813Data = async ( config?: YWRequestConfig): Promise<API49813Res> => {
  
    if ( isMount ) {
      setIsAPI49813Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API49813Res>(`${basePath}/corp-admin/project/bi/view/v2`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI49813(res || {} as API49813Res);
        setIsAPI49813Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI49813Loading(false);
      }
      return false as unknown as API49813Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI49813Loading,
    dataAPI49813,
    fetchAPI49813Data,
    requestUrl,
  }
}

